<template>
  <div class="containerInfo">
    <el-row type="flex" justify="space-around">
      <el-col :lg="14" :sm="24" :xs="24">
        <el-card class="box-card">
          <el-form ref="postForm" :model="form" :rules="rules">
            <div v-if="isProfessionTech || isTechnique ? true : false">
              <el-row>
                <el-col :span="20" style="display: flex; align-items: center">
                  <img
                    src="@/assets/recruit/juxing.png"
                    alt="Logo"
                    style="margin-right: 12px"
                  /><span class="spanTitle" style="font-weight: bold"
                    >教育背景(学习阶段请按照从低到高依次往下填写)
                    {{
                      isTechnique && !isView ? "（限大专或高职毕业生）" : ""
                    }}</span
                  >
                </el-col>
                <el-col :span="4"
                  ><el-tag style="float: right">{{
                    isProfessionTech ? "专技类" : "技能类"
                  }}</el-tag></el-col
                >
              </el-row>
              <el-row v-if="false">
                <span>
                  <br />{{
                    isProfessionTech
                      ? "(硕士/非学术型，务必备注：大四时是否具有推免资格，硕士所修学分是否不低于学术型的标准)"
                      : ""
                  }}</span
                >
              </el-row>
              <el-divider />
              <!--专技类-->
              <!--              <div v-if="isProfessionTech">-->
              <div>
                <el-row>
                  <el-col :span="18">
                    <el-form-item
                      label="最高学历(提醒：在读人员请填写毕业时拟取得学位;请在选择毕业专业时确保学科选择正确):"
                      prop="topDegree"
                      :required="true"
                    >
                      <zr-combobox
                        v-model="form.topDegree"
                        placeholder="选择最高教育经历"
                        :data-array="[
                          { name: '其它', code: '其它' },
                          { name: '大学专科毕业', code: '大学专科毕业' },
                          { name: '大学本科毕业', code: '大学本科毕业' },
                          { name: '硕士研究生毕业', code: '硕士研究生毕业' },
                          { name: '博士研究生毕业', code: '博士研究生毕业' },
                        ]"
                        value-field="code"
                        label-field="name"
                        clearable
                        style="width: 135px"
                        @change="topDegreeChange"
                      ></zr-combobox>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      style="border: 1px solid #1890ff; margin-left: 10px"
                      @click="addPhase"
                      ><i class="el-icon-plus" style="color: #1890ff"
                        ><a style="color: #1890ff">添加阶段</a></i
                      ></el-button
                    >
                    &nbsp; * <span style="color: gray">(学习阶段必填)</span>
                  </el-col>
                </el-row>
                <el-card
                  v-for="row in form.experienceList"
                  :key="row.phase"
                  style="background-color: #f5f7fa"
                >
                  <div slot="header">
                    <zr-combobox
                      v-model="row.phase"
                      placeholder="阶段"
                      :data-array="[
                        { name: '其它', code: '其它' },
                        { name: '大学专科毕业', code: '大学专科毕业' },
                        { name: '大学本科毕业', code: '大学本科毕业' },
                        { name: '硕士研究生毕业', code: '硕士研究生毕业' },
                        { name: '博士研究生毕业', code: '博士研究生毕业' },
                      ]"
                      value-field="code"
                      label-field="name"
                      @change="phaseChange(row)"
                    ></zr-combobox>
                    <el-button
                      style="float: right; padding: 3px 0"
                      icon="el-icon-minus"
                      type="text"
                      @click="deletePhase(row)"
                      >删除</el-button
                    >
                  </div>
                  <el-row>
                    <el-col :lg="8" :sm="24" :xs="24">
                      <el-form-item
                        label="开始日期:"
                        label-width="100px"
                        :required="true"
                      >
                        <el-date-picker
                          v-model="row.startDate"
                          align="right"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          placeholder="选择开始日期"
                          style="width: 135px"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="8" :sm="24" :xs="24">
                      <el-form-item
                        label="结束日期:"
                        label-width="100px"
                        :required="true"
                      >
                        <el-date-picker
                          v-model="row.endDate"
                          align="right"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          placeholder="选择结束日期"
                          style="width: 135px"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="8" :sm="24" :xs="24">
                      <el-form-item
                        label="毕业单位:"
                        prop="university"
                        label-width="100px"
                      >
                        <el-col :span="16">
                          <el-select
                            v-model="row.university"
                            clearable
                            filterable
                            @change="universityChange(row)"
                          >
                            <el-option
                              v-for="item in schoolArray"
                              :key="item.code"
                              :label="item.name"
                              :value="item.code"
                            />
                          </el-select>
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="row.isShowOtherSchool">
                    <el-col :lg="24" :sm="24" :xs="24">
                      <el-form-item
                        label="其他毕业单位名称:"
                        label-width="100px"
                        prop="otherSchool"
                      >
                        <el-col :span="17">
                          <el-input
                            v-model="row.otherSchool"
                            placeholder="请输入其他毕业单位名称"
                            maxlength="30"
                          />
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="8" :sm="24" :xs="24">
                      <el-form-item label="学院/系:" label-width="100px">
                        <el-col :span="16">
                          <el-input
                            v-model="row.institutions"
                            placeholder="请输入学院/系"
                            maxlength="15"
                          />
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="8" :sm="24" :xs="24">
                      <el-form-item
                        label="一级学科:"
                        label-width="100px"
                        :required="true"
                      >
                        <el-col :span="16">
                          <select-tree-new
                            v-model="row.studyField"
                            :row="row"
                            :tree-data="loadTreeData(row)"
                          ></select-tree-new>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="8" :sm="24" :xs="24">
                      <el-form-item
                        label="毕业专业:"
                        label-width="100px"
                        :required="true"
                      >
                        <el-col :span="16">
                          <!--                          <select-tree-->
                          <!--                            v-model="row.majorCourse"-->
                          <!--                            :row="row"-->
                          <!--                            :tree-data="loadTreeData(row)"-->
                          <!--                            @change="majorCourseChnage(row)"-->
                          <!--                          ></select-tree>-->
                          <ZrDetailSelect
                            v-model="row.majorCourse"
                            :parent-value="row.studyField"
                            :tree-data="loadTreeData1(row)"
                            :emit-path="true"
                          />
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="8" :sm="24" :xs="24">
                      <el-form-item label="专业总人数:" label-width="100px">
                        <el-col :span="16">
                          <el-input
                            v-model="row.totalNumber"
                            onkeyup="value=value.replace(/[^\d]/g,'')"
                            placeholder="只能为数字"
                            maxlength="5"
                            @blur="(e) => salaryNewChange(e, row)"
                          />
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="8" :sm="24" :xs="24">
                      <el-form-item label="综合排名:" label-width="100px">
                        <el-col :span="16">
                          <el-input
                            v-model="row.rankNum"
                            onkeyup="value=value.replace(/[^\d]/g,'')"
                            placeholder="综合排名只能为数字"
                            maxlength="5"
                            @blur="(e) => salaryChange(e, row)"
                          />
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="8" :sm="24" :xs="24">
                      <el-form-item
                        label="学习形式:"
                        prop="learningShape"
                        label-width="100px"
                      >
                        <el-col :span="16">
                          <el-select
                            v-model="row.learningShape"
                            clearable
                            filterable
                          >
                            <el-option
                              v-for="item in basicLearningFormat"
                              :key="item.code"
                              :label="item.name"
                              :value="item.code"
                            />
                          </el-select>
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="24" :sm="24" :xs="24">
                      <el-form-item label="备注:" label-width="100px">
                        <el-col :span="17">
                          <el-input
                            v-model="row.remark"
                            placeholder="请输入备注"
                            maxlength="30"
                          />
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
                <el-row>
                  <el-col :span="18">
                    <el-form-item
                      label="最高学位(提醒：在读人员请填写毕业时拟取得学位;请在选择毕业专业时确保学科选择正确):"
                      prop="topDegree"
                      :required="true"
                    >
                      <zr-combobox
                        v-model="form.topDegreeName"
                        placeholder="选择最高学位"
                        :data-array="basicDegree"
                        value-field="code"
                        label-field="name"
                        clearable
                        filterable
                        style="width: 135px"
                        @change="topDegreeNameChange"
                      ></zr-combobox>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <!--                  <el-button-->
                    <!--                    style="float: left; padding: 3px 0"-->
                    <!--                    icon="el-icon-circle-plus-outline"-->
                    <!--                    type="primary"-->
                    <!--                    @click="addDegree"-->
                    <!--                    >添加学位情况</el-button-->
                    <!--                  >-->
                    <el-button
                      style="border: 1px solid #1890ff; margin-left: 10px"
                      @click="addDegree"
                      ><i class="el-icon-plus" style="color: #1890ff"
                        ><a style="color: #1890ff">添加学位情况</a></i
                      ></el-button
                    >
                  </el-col>
                </el-row>
                <el-card
                  v-for="row in form.degreeList"
                  :key="row.degreeName"
                  style="background-color: #f5f7fa"
                >
                  <div slot="header">
                    <zr-combobox
                      v-model="row.degreeName"
                      placeholder="学位"
                      :data-array="basicDegree"
                      value-field="code"
                      label-field="name"
                    ></zr-combobox>
                    <el-button
                      style="float: right; padding: 3px 0"
                      icon="el-icon-minus"
                      type="text"
                      @click="deleteDegree(row)"
                      >删除</el-button
                    >
                  </div>
                  <el-row>
                    <el-col :lg="8" :sm="24" :xs="24">
                      <el-form-item
                        label="开始日期:"
                        label-width="100px"
                        :required="true"
                      >
                        <el-date-picker
                          v-model="row.startDate"
                          align="right"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          placeholder="选择开始日期"
                          style="width: 135px"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="8" :sm="24" :xs="24">
                      <el-form-item
                        label="结束日期:"
                        label-width="100px"
                        :required="true"
                      >
                        <el-date-picker
                          v-model="row.endDate"
                          align="right"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          placeholder="选择结束日期"
                          style="width: 135px"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="8" :sm="24" :xs="24">
                      <el-form-item
                        label="学位授予单位:"
                        prop="degreeDept"
                        label-width="100px"
                      >
                        <el-col :span="16">
                          <el-select
                            v-model="row.degreeDept"
                            clearable
                            filterable
                            @change="degreeDeptChange(row)"
                          >
                            <el-option
                              v-for="item in schoolArray"
                              :key="item.code"
                              :label="item.name"
                              :value="item.code"
                            />
                          </el-select>
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row v-if="row.isShowOtherDept">
                    <el-col :lg="24" :sm="24" :xs="24">
                      <el-form-item
                        label="其他具体单位名称:"
                        label-width="100px"
                        prop="otherDept"
                      >
                        <el-col :span="17">
                          <el-input
                            v-model="row.otherDept"
                            placeholder="请输入其他具体单位名称"
                            maxlength="30"
                          />
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="8" :sm="24" :xs="24">
                      <el-form-item
                        label="获学位学科:"
                        label-width="100px"
                        :required="true"
                      >
                        <el-col :span="16">
                          <select-tree-new
                            v-model="row.degreeScience"
                            :row="row"
                            :tree-data="loadTreeData(row)"
                          ></select-tree-new
                        ></el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="8" :sm="24" :xs="24">
                      <el-form-item
                        label="获学位专业:"
                        label-width="100px"
                        :required="true"
                      >
                        <el-col :span="16">
                          <!--                          <el-input-->
                          <!--                            v-model="row.degreeStudyField"-->
                          <!--                            placeholder="请输入获学位专业"-->
                          <!--                            maxlength="30"-->
                          <!--                        />-->
<!--                          <select-tree-->
<!--                            v-model="row.degreeStudyField"-->
<!--                            :row="row"-->
<!--                            :tree-data="loadTreeData(row)"-->
<!--                            @change="degreeStudyFieldChange(row)"-->
<!--                          ></select-tree>-->
                          <ZrDetailSelect
                              v-model="row.degreeStudyField"
                              :parent-value="row.degreeScience"
                              :tree-data="loadTreeData1(row)"
                              :emit-path="true"
                          />
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="8" :sm="24" :xs="24">
                      <el-form-item
                        label="学习形式:"
                        prop="learningFormat"
                        label-width="100px"
                      >
                        <el-col :span="16">
                          <el-select
                            v-model="row.learningFormat"
                            clearable
                            filterable
                          >
                            <el-option
                              v-for="item in basicLearningFormat"
                              :key="item.code"
                              :label="item.name"
                              :value="item.code"
                            /> </el-select
                        ></el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
              </div>
              <!--技能类-->
              <!--              <div v-if="isTechnique">-->
              <!--                <el-row>-->
              <!--                  <el-col span="18">-->
              <!--                    <el-form-item label=""> </el-form-item>-->
              <!--                  </el-col>-->
              <!--                  <el-col span="6">-->
              <!--                    <el-button-->
              <!--                      style="-->
              <!--                        border: 1px solid #1890ff;-->
              <!--                        margin-left: 10px;-->
              <!--                        margin-bottom: 10px;-->
              <!--                      "-->
              <!--                      @click="addPhase"-->
              <!--                      ><i class="el-icon-plus" style="color: #1890ff"-->
              <!--                        ><a style="color: #1890ff">添加阶段</a></i-->
              <!--                      ></el-button-->
              <!--                    >-->
              <!--                    &nbsp; * <span style="color: gray">(学习阶段必填)</span>-->
              <!--                  </el-col>-->
              <!--                </el-row>-->
              <!--                <el-card-->
              <!--                  v-for="row in form.experienceList"-->
              <!--                  :key="row.phase"-->
              <!--                  style="background-color: #f5f7fa"-->
              <!--                >-->
              <!--                  <div slot="header">-->
              <!--                    <zr-combobox-->
              <!--                      v-model="row.phase"-->
              <!--                      placeholder="阶段"-->
              <!--                      :data-array="[-->
              <!--                        // { name: '大专', code: '大专' },-->
              <!--                        // { name: '本科', code: '本科' },-->
              <!--                        { name: '大学专科毕业', code: '大学专科毕业' },-->
              <!--                        { name: '大学本科毕业', code: '大学本科毕业' },-->
              <!--                      ]"-->
              <!--                      value-field="code"-->
              <!--                      label-field="name"-->
              <!--                      @change="phaseChange(row)"-->
              <!--                    ></zr-combobox>-->
              <!--                    <el-button-->
              <!--                      style="float: right; padding: 3px 0"-->
              <!--                      icon="el-icon-minus"-->
              <!--                      type="text"-->
              <!--                      @click="deletePhase(row)"-->
              <!--                      >删除</el-button-->
              <!--                    >-->
              <!--                  </div>-->
              <!--                  <el-row>-->
              <!--                    <el-col :lg="8" :sm="24" :xs="24">-->
              <!--                      <el-form-item-->
              <!--                        label="开始日期:"-->
              <!--                        :required="true"-->
              <!--                        label-width="100px"-->
              <!--                      >-->
              <!--                        <el-date-picker-->
              <!--                          v-model="row.startDate"-->
              <!--                          align="right"-->
              <!--                          type="date"-->
              <!--                          format="yyyy-MM-dd"-->
              <!--                          value-format="yyyy-MM-dd"-->
              <!--                          placeholder="选择开始日期"-->
              <!--                          style="width: 135px"-->
              <!--                        ></el-date-picker>-->
              <!--                      </el-form-item>-->
              <!--                    </el-col>-->
              <!--                    <el-col :lg="8" :sm="24" :xs="24">-->
              <!--                      <el-form-item-->
              <!--                        label="结束日期:"-->
              <!--                        :required="true"-->
              <!--                        label-width="100px"-->
              <!--                      >-->
              <!--                        <el-date-picker-->
              <!--                          v-model="row.endDate"-->
              <!--                          align="right"-->
              <!--                          type="date"-->
              <!--                          format="yyyy-MM-dd"-->
              <!--                          value-format="yyyy-MM-dd"-->
              <!--                          placeholder="选择结束日期"-->
              <!--                          style="width: 135px"-->
              <!--                        ></el-date-picker>-->
              <!--                      </el-form-item>-->
              <!--                    </el-col>-->
              <!--                    <el-col :lg="8" :sm="24" :xs="24">-->
              <!--                      <el-form-item-->
              <!--                        label="毕业单位:"-->
              <!--                        prop="university"-->
              <!--                        label-width="100px"-->
              <!--                      >-->
              <!--                        <el-col :span="16"-->
              <!--                          ><el-select-->
              <!--                            v-model="row.university"-->
              <!--                            clearable-->
              <!--                            filterable-->
              <!--                          >-->
              <!--                            <el-option-->
              <!--                              v-for="item in schoolArray"-->
              <!--                              :key="item.code"-->
              <!--                              :label="item.name"-->
              <!--                              :value="item.code"-->
              <!--                            />-->
              <!--                          </el-select>-->
              <!--                        </el-col>-->
              <!--                      </el-form-item>-->
              <!--                    </el-col>-->
              <!--                  </el-row>-->
              <!--                  <el-row>-->
              <!--                    <el-col :lg="8" :sm="24" :xs="24">-->
              <!--                      <el-form-item label="学院/系:" label-width="100px">-->
              <!--                        <el-col :span="16">-->
              <!--                          <el-input-->
              <!--                            v-model="row.institutions"-->
              <!--                            placeholder="请输入学院/系"-->
              <!--                            maxlength="15"-->
              <!--                          />-->
              <!--                        </el-col>-->
              <!--                      </el-form-item>-->
              <!--                    </el-col>-->
              <!--                    <el-col :lg="8" :sm="24" :xs="24">-->
              <!--                      <el-form-item-->
              <!--                        label="一级学科:"-->
              <!--                        :required="true"-->
              <!--                        label-width="100px"-->
              <!--                      >-->
              <!--                        <el-col :span="16">-->
              <!--                          <select-tree-->
              <!--                            v-model="row.studyField"-->
              <!--                            :row="row"-->
              <!--                            :tree-data="loadTreeData(row)"-->
              <!--                          ></select-tree>-->
              <!--                        </el-col>-->
              <!--                      </el-form-item>-->
              <!--                    </el-col>-->
              <!--                    <el-col :lg="8" :sm="24" :xs="24">-->
              <!--                      <el-form-item-->
              <!--                        label="毕业专业:"-->
              <!--                        :required="true"-->
              <!--                        label-width="100px"-->
              <!--                      >-->
              <!--                        <el-col :span="16">-->
              <!--                          <el-input-->
              <!--                            v-model="row.majorCourse"-->
              <!--                            placeholder="请输入获学位专业"-->
              <!--                            maxlength="30"-->
              <!--                          />-->
              <!--                        </el-col>-->
              <!--                      </el-form-item>-->
              <!--                    </el-col>-->
              <!--                  </el-row>-->
              <!--                  <el-row>-->
              <!--                    <el-col :lg="8" :sm="24" :xs="24">-->
              <!--                      <el-form-item label="专业总人数:" label-width="100px">-->
              <!--                        <el-input-->
              <!--                          v-model="row.totalNumber"-->
              <!--                          onkeyup="value=value.replace(/[^\d]/g,'')"-->
              <!--                          placeholder="只能为数字"-->
              <!--                          maxlength="5"-->
              <!--                          @blur="(e) => salaryNewChange(e, row)"-->
              <!--                        />-->
              <!--                      </el-form-item>-->
              <!--                    </el-col>-->
              <!--                    <el-col :lg="8" :sm="24" :xs="24">-->
              <!--                      <el-form-item label="综合排名:" label-width="100px">-->
              <!--                        <el-col :span="16">-->
              <!--                          <el-input-->
              <!--                            v-model="row.rankNum"-->
              <!--                            onkeyup="value=value.replace(/[^\d]/g,'')"-->
              <!--                            placeholder="综合排名只能为数字"-->
              <!--                            maxlength="5"-->
              <!--                            @blur="(e) => salaryChange(e, row)"-->
              <!--                          />-->
              <!--                        </el-col>-->
              <!--                      </el-form-item>-->
              <!--                    </el-col>-->
              <!--                    <el-col :lg="8" :sm="24" :xs="24">-->
              <!--                      <el-form-item-->
              <!--                        label="学习形式:"-->
              <!--                        prop="learningShape"-->
              <!--                        label-width="100px"-->
              <!--                      >-->
              <!--                        <el-col :span="16"-->
              <!--                          ><el-select-->
              <!--                            v-model="row.learningShape"-->
              <!--                            clearable-->
              <!--                            filterable-->
              <!--                          >-->
              <!--                            <el-option-->
              <!--                              v-for="item in basicLearningFormat"-->
              <!--                              :key="item.code"-->
              <!--                              :label="item.name"-->
              <!--                              :value="item.code"-->
              <!--                            />-->
              <!--                          </el-select>-->
              <!--                        </el-col>-->
              <!--                      </el-form-item>-->
              <!--                    </el-col>-->
              <!--                  </el-row>-->
              <!--                  <el-row>-->
              <!--                    <el-col :lg="24" :sm="24" :xs="24">-->
              <!--                      <el-form-item label="备注:" label-width="100px">-->
              <!--                        <el-col :span="16">-->
              <!--                          <el-input-->
              <!--                            v-model="row.remark"-->
              <!--                            placeholder="请输入备注"-->
              <!--                            maxlength="15"-->
              <!--                          />-->
              <!--                        </el-col>-->
              <!--                      </el-form-item>-->
              <!--                    </el-col>-->
              <!--                  </el-row>-->
              <!--                </el-card>-->
              <!--                <el-row>-->
              <!--                  <el-col span="18">-->
              <!--                    <el-form-item label="最高学位:" prop="topDegree">-->
              <!--                      <zr-combobox-->
              <!--                        v-model="form.topDegreeName"-->
              <!--                        placeholder="选择最高学位"-->
              <!--                        :data-array="basicDegree"-->
              <!--                        value-field="code"-->
              <!--                        label-field="name"-->
              <!--                        clearable-->
              <!--                        filterable-->
              <!--                        style="width: 135px"-->
              <!--                        @change="topDegreeNameChange"-->
              <!--                      ></zr-combobox>-->
              <!--                    </el-form-item>-->
              <!--                  </el-col>-->
              <!--                  <el-col span="6">-->
              <!--                    <el-button-->
              <!--                      style="border: 1px solid #1890ff; margin-left: 10px"-->
              <!--                      @click="addDegree"-->
              <!--                      ><i class="el-icon-plus" style="color: #1890ff"-->
              <!--                        ><a style="color: #1890ff">添加学位情况</a></i-->
              <!--                      ></el-button-->
              <!--                    >-->
              <!--                  </el-col>-->
              <!--                </el-row>-->
              <!--                <el-card-->
              <!--                  v-for="row in form.degreeList"-->
              <!--                  :key="row.degreeName"-->
              <!--                  style="background-color: #f5f7fa"-->
              <!--                >-->
              <!--                  <div slot="header">-->
              <!--                    <zr-combobox-->
              <!--                      v-model="row.degreeName"-->
              <!--                      placeholder="学位"-->
              <!--                      :data-array="basicDegree"-->
              <!--                      value-field="code"-->
              <!--                      label-field="name"-->
              <!--                    ></zr-combobox>-->
              <!--                    <el-button-->
              <!--                      style="float: right; padding: 3px 0"-->
              <!--                      icon="el-icon-minus"-->
              <!--                      type="text"-->
              <!--                      @click="deleteDegree(row)"-->
              <!--                      >删除</el-button-->
              <!--                    >-->
              <!--                  </div>-->
              <!--                  <el-row>-->
              <!--                    <el-col :lg="8" :sm="24" :xs="24">-->
              <!--                      <el-form-item-->
              <!--                        label="开始日期:"-->
              <!--                        label-width="100px"-->
              <!--                        :required="true"-->
              <!--                      >-->
              <!--                        <el-date-picker-->
              <!--                          v-model="row.startDate"-->
              <!--                          align="right"-->
              <!--                          type="date"-->
              <!--                          format="yyyy-MM-dd"-->
              <!--                          value-format="yyyy-MM-dd"-->
              <!--                          placeholder="选择开始日期"-->
              <!--                          style="width: 135px"-->
              <!--                        ></el-date-picker>-->
              <!--                      </el-form-item>-->
              <!--                    </el-col>-->
              <!--                    <el-col :lg="8" :sm="24" :xs="24">-->
              <!--                      <el-form-item-->
              <!--                        label="结束日期:"-->
              <!--                        label-width="100px"-->
              <!--                        :required="true"-->
              <!--                      >-->
              <!--                        <el-date-picker-->
              <!--                          v-model="row.endDate"-->
              <!--                          align="right"-->
              <!--                          type="date"-->
              <!--                          format="yyyy-MM-dd"-->
              <!--                          value-format="yyyy-MM-dd"-->
              <!--                          placeholder="选择结束日期"-->
              <!--                          style="width: 135px"-->
              <!--                        ></el-date-picker>-->
              <!--                      </el-form-item>-->
              <!--                    </el-col>-->
              <!--                    <el-col :lg="8" :sm="24" :xs="24">-->
              <!--                      <el-form-item-->
              <!--                        label="学位授予单位:"-->
              <!--                        prop="degreeDept"-->
              <!--                        label-width="120px"-->
              <!--                      >-->
              <!--                        <el-col :span="16"-->
              <!--                          ><el-select-->
              <!--                            v-model="row.degreeDept"-->
              <!--                            clearable-->
              <!--                            filterable-->
              <!--                          >-->
              <!--                            <el-option-->
              <!--                              v-for="item in schoolArray"-->
              <!--                              :key="item.code"-->
              <!--                              :label="item.name"-->
              <!--                              :value="item.code"-->
              <!--                            />-->
              <!--                          </el-select>-->
              <!--                        </el-col>-->
              <!--                      </el-form-item>-->
              <!--                    </el-col>-->
              <!--                  </el-row>-->
              <!--                  <el-row>-->
              <!--                    <el-col :lg="8" :sm="24" :xs="24">-->
              <!--                      <el-form-item-->
              <!--                        label="获学位学科:"-->
              <!--                        label-width="100px"-->
              <!--                        :required="true"-->
              <!--                      >-->
              <!--                        <el-col :span="16">-->
              <!--                          <select-tree-->
              <!--                            v-model="row.degreeScience"-->
              <!--                            :row="row"-->
              <!--                            :tree-data="loadTreeData(row)"-->
              <!--                          ></select-tree>-->
              <!--                        </el-col>-->
              <!--                      </el-form-item>-->
              <!--                    </el-col>-->
              <!--                    <el-col :lg="8" :sm="24" :xs="24">-->
              <!--                      <el-form-item-->
              <!--                        label="获学位专业:"-->
              <!--                        label-width="120px"-->
              <!--                        :required="true"-->
              <!--                      >-->
              <!--                        <el-col :span="16">-->
              <!--                          <el-input-->
              <!--                            v-model="row.degreeStudyField"-->
              <!--                            placeholder="请输入获学位专业"-->
              <!--                            maxlength="30"-->
              <!--                          />-->
              <!--                        </el-col>-->
              <!--                      </el-form-item>-->
              <!--                    </el-col>-->
              <!--                    <el-col :lg="8" :sm="24" :xs="24">-->
              <!--                      <el-form-item-->
              <!--                          label="学习形式:"-->
              <!--                          prop="learningFormat"-->
              <!--                          label-width="100px"-->
              <!--                      >-->
              <!--                        <el-col :span="16"-->
              <!--                        ><el-select-->
              <!--                            v-model="row.learningFormat"-->
              <!--                            clearable-->
              <!--                            filterable-->
              <!--                        >-->
              <!--                          <el-option-->
              <!--                              v-for="item in basicLearningFormat"-->
              <!--                              :key="item.code"-->
              <!--                              :label="item.name"-->
              <!--                              :value="item.code"-->
              <!--                          />-->
              <!--                        </el-select>-->
              <!--                        </el-col>-->
              <!--                      </el-form-item>-->
              <!--                    </el-col>-->
              <!--                  </el-row>-->
              <!--                </el-card>-->
              <!--              </div>-->
              <el-row type="flex" justify="space-around">
                <el-col :lg="24" :sm="24" :xs="24">
                  <el-card class="box-card">
                    <el-form ref="postForm" :model="form" label-position="top">
                      <div>
                        <div>
                          <el-row>
                            <el-col :span="18">
                              <el-form-item label="语言情况:"> </el-form-item>
                            </el-col>
                            <el-col :span="6">
                              <el-button
                                style="
                                  border: 1px solid #1890ff;
                                  margin-left: 20px;
                                "
                                @click="addLanguageInfo"
                                ><i class="el-icon-plus" style="color: #1890ff"
                                  ><a style="color: #1890ff">添加语言情况</a></i
                                ></el-button
                              >
                            </el-col>
                          </el-row>
                        </div>
                        <el-card
                          v-for="row in form.languageInfoList"
                          :key="row.id"
                          style="background-color: #f5f7fa"
                        >
                          <div slot="header">
                            <el-button
                              style="float: right; padding: 3px 0"
                              icon="el-icon-minus"
                              type="text"
                              @click="delLanguageInfo(row)"
                              >删除</el-button
                            >
                          </div>
                          <el-row>
                            <el-col :lg="8" :sm="24" :xs="24">
                              <el-form-item
                                label="语言语种:"
                                label-width="100px"
                                :required="true"
                              >
                                <el-select
                                  v-model="row['languageClass']"
                                  @change="languageRowChange(row)"
                                >
                                  <el-option
                                    v-for="item in basicLanguage"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code"
                                  >
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </el-col>
                            <el-col
                              v-show="row.showDic"
                              :lg="8"
                              :sm="24"
                              :xs="24"
                            >
                              <el-form-item
                                label="证书:"
                                label-width="100px"
                                :required="true"
                              >
                                <el-select
                                  v-model="row['languageCertificate']"
                                  filterable
                                >
                                  <el-option
                                    v-for="item in basicEnglishLevel"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code"
                                  >
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </el-col>
                            <el-col
                              v-show="!row.showDic"
                              :lg="8"
                              :sm="24"
                              :xs="24"
                            >
                              <el-form-item
                                label="证书:"
                                label-width="100px"
                                :required="true"
                              >
                                <el-col :span="18">
                                  <el-input
                                    v-model="row['languageCertificate']"
                                    maxlength="25"
                                    clearable
                                  ></el-input>
                                </el-col>
                              </el-form-item>
                            </el-col>
                            <el-col :lg="8" :sm="24" :xs="24">
                              <el-form-item
                                label="成绩:"
                                label-width="100px"
                                :required="true"
                              >
                                <el-input
                                  v-model="row['languageScore']"
                                  size="mini"
                                  maxlength="500"
                                  clearable
                                ></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-card>
                      </div>
                    </el-form>
                  </el-card>
                </el-col>
              </el-row>
            </div>
            <div style="text-align: center">
              <slot name="footBtn" :form="form">
                <el-button icon="el-icon-circle-check" @click="preActive"
                  >上一步</el-button
                >
                <el-button
                  icon="el-icon-circle-check"
                  type="primary"
                  @click="nextActice"
                  >下一步</el-button
                >
                <el-button icon="el-icon-back" plain @click="back"
                  >返回</el-button
                >
              </slot>
            </div>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import isMobile from "@/utils/device";
import { getBasicData, getBasicDataBatch } from "@/api/job/postInfo";
import { getUniversity } from "@/api/recruit/applicant/positionList";
import settingHelp from "@/config/localSetting";
import store from "@/store";
import SelectTree from "@/views/recruit/applicant/selectTree.vue";
import SelectTreeNew from "@/views/recruit/applicant/selectTreeNew.vue";
import SelectProEduTree from "@/components/zr/dialog/selectProEduTree.vue";
import ZrDetailSelect from "@/views/recruit/applicant/zrDetailSelect.vue";
const config = settingHelp.getConfig();
const { remoteURL } = config;
const token1 = localStorage.getItem("token");
const token2 = store.getters["user/accessToken"];
const token = token2 ? token2 : token1;
export default {
  name: "PersonalDgreeInfo",
  components: { SelectTree, SelectTreeNew, ZrDetailSelect },
  props: {
    form: {
      type: Object,
      default() {
        return {};
      },
    },
    isPost: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    isView: {
      type: Boolean,
      default: false,
    },
    isTechnique: {
      type: Boolean,
      default: false,
    },
    isProfessionTech: {
      type: Boolean,
      default: false,
    },
    proEduCatalog: {
      type: Array,
      default() {
        return [];
      },
    },
    studyCatalog: {
      type: Array,
      default() {
        return [];
      },
    },
    oneLevelStudy: {
      type: Array,
      default() {
        return [];
      },
    },
    proOneLevelStudy: {
      type: Array,
      default() {
        return [];
      },
    }
    // proEduCatalog:[],//职业教育目录
    // studyCatalog:[],//本科教育目录
  },
  data() {
    return {
      // isRequired: true, //学生编辑模式
      // isView: false, // 管理员查看模式
      // isTechnique: false, // 技能类
      // isProfessionTech: true, // 专技类
      isMarriedRequired: false,
      schoolArray: [],
      basicLearningFormat: [], //学习形式数据字典
      basicDegree: [], //学位数据字典
      // proEduCatalog:[],//职业教育目录
      // studyCatalog:[],//本科教育目录
      rules: {
        university: [
          { required: true, message: "请选择毕业单位", trigger: "blur" },
        ],
        otherSchool: [
          {
            required: true,
            message: "请填写其他毕业单位名称",
            trigger: "blur",
          },
        ],
        learningShape: [
          { required: true, message: "请选择学历学习形式", trigger: "blur" },
        ],
        degreeDept: [
          { required: true, message: "请选择学位授予单位", trigger: "blur" },
        ],
        otherDept: [
          {
            required: true,
            message: "请填写其他具体单位名称",
            trigger: "blur",
          },
        ],
        learningFormat: [
          { required: true, message: "请选择学位学习形式", trigger: "blur" },
        ],
        languageScore: [
          { required: true, message: "请输入证书成绩", trigger: "blur" },
        ],
      },
      basicEnglishLevel: [], //英语水平
      basicLanguage: [], //语言语种
      languageInfoColumns: [
        { name: "语言语种", code: "languageClass", needDrawCell: true },
        {
          name: "证书",
          code: "languageCertificate",
          needDrawCell: true,
        },
        { name: "证书成绩", code: "languageScore", needDrawCell: true },
        { name: "操作", code: "operate", needDrawCell: true },
      ],
    };
  },
  computed: {
    ...mapGetters({
      userPhone: "user/userPhone",
      userName: "user/userName",
      userCode: "user/userCode",
    }),
  },
  async created() {
    // 判断是否是移动设备
    this.isMb = await isMobile();
    // 路由参数 判断页面状态
    if (this.$route.query.isView) {
      this.isView = true;
      this.isRequired = false;
    }
    await this.getSchoolArray();
    await this.loadBasicArray();
    // await this.getLearningFormatArray();
    // await this.getEnglishLevelArray();
    // await this.getLanguageArray();
    // await this.getDegreeArray();
    // await this.getProEduCatalog();
    // await this.getStudyCatalog();
    if (this.form.postSendId) this.postSendId = this.form.postSendId;
    if (this.form.isProfessionTech)
      this.isProfessionTech = this.form.isProfessionTech;
    if (this.form.isTechnique) this.isTechnique = this.form.isTechnique;
    if (this.form.languageInfoList && this.form.languageInfoList.length > 0) {
      this.form.languageInfoList.forEach((item) => {
        if (item.languageClass === "英语") {
          this.$set(item, "showDic", true);
        }
      });
    }
    // 学历列表判断
    if (this.isProfessionTech && !this.form.experienceList) {
      // 专技类
      // this.form.experienceList = [{ phase: "本科", resumeId: this.form.id }];
      this.form.experienceList = [
        { phase: "大学本科毕业", resumeId: this.form.id, studyField: "" },
      ];
    }
    if (this.isProfessionTech && !this.form.degreeList) {
      // 专技类
      // this.form.experienceList = [{ phase: "本科", resumeId: this.form.id }];
      this.form.degreeList.push({ degreeName: "学士", resumeId: this.form.id });
    }
    if (this.isTechnique && !this.form.degreeList) {
      this.form.degreeList = [{ degreeName: "无", resumeId: this.form.id }];
    }
    if (
      this.isTechnique &&
      (!this.form.experienceList || !this.form.experienceList.length)
    ) {
      // 技能类
      // this.form.experienceList = [{ phase: "大专", resumeId: this.form.id }];
      this.form.experienceList = [
        { phase: "大学专科毕业", resumeId: this.form.id },
      ];
      this.columns = [
        {
          code: "phase",
          name: "阶段",
          width: "60",
        },
        {
          code: "startDate",
          name: "开始时间",
          needDrawCell: true,
          width: "120",
        },
        {
          code: "endDate",
          name: "结束时间",
          needDrawCell: true,
          width: "120",
        },
        {
          code: "university",
          name: "学校",
          needDrawCell: true,
          width: "155",
        },
        {
          code: "institutions",
          name: "学院/系",
          needDrawCell: true,
          width: "155",
        },
        {
          code: "studyField",
          name: "专业",
          needDrawCell: true,
          width: "155",
        },
        {
          code: "remark",
          name: "备注",
          needDrawCell: true,
          width: "150",
        },
      ];
    }
  },
  methods: {
    /**
     * 校验级联选择器的值是否为最后一级
     *
     * @param {String} value - 逗号分隔的值字符串，如 "110000,110101" 或 "110101"
     * @param {Array} options - 级联选择器的选项数组（树形结构）
     * @returns {Object} - { valid: Boolean, message: String, lastValue: String, fullPath: Array }
     */
    validateLastLevelCascader(value, options) {
      // 空值校验
      if (!value || typeof value !== "string") {
        return {
          valid: false,
          message: "请选择",
          lastValue: null,
          fullPath: [],
        };
      }
      // 分割字符串获取各级值
      const values = value
        .split(",")
        .map((v) => v.trim())
        .filter((v) => v);
      if (values.length === 0) {
        return {
          valid: false,
          message: "请选择",
          lastValue: null,
          fullPath: [],
        };
      }
      // 获取最后一个层级的值
      const lastValue = values[values.length - 1];
      // 递归查找节点
      const findNode = (nodes) => {
        for (const node of nodes) {
          if (node.value === lastValue || node.code === lastValue) {
            return node;
          }
          if (node.children && node.children.length > 0) {
            const found = findNode(node.children);
            if (found) return found;
          }
        }
        return null;
      };
      const node = findNode(options);
      // 未找到该值
      if (!node) {
        return {
          valid: false,
          message: "选择无效，请重新选择",
          lastValue,
          fullPath: values,
        };
      }
      // 检查是否为最后一级（没有 children 或 children 为空数组）
      const isLastLevel = !node.children || node.children.length === 0;
      if (!isLastLevel) {
        return {
          valid: false,
          message: "请选择完整的地址（选择到最后一级别）",
          lastValue,
          fullPath: values,
        };
      }
      // 校验通过
      return {
        valid: true,
        message: "校验通过",
        lastValue,
        fullPath: values,
      };
    },
    /**
     * 简化版 - 只返回是否有效
     * @param {String} value - 逗号分隔的值字符串
     * @param {Array} options - 级联选择器选项
     * @returns {Boolean}
     */ isLastLevelCascaderValue(value, options) {
      const result = this.validateLastLevelCascader(value, options);
      return result.valid;
    },
    universityChange(row) {
      if (row.university && row.university === "其他") {
        row.isShowOtherSchool = true;
      } else {
        row.isShowOtherSchool = false;
        this.$set(row, "otherSchool", "");
      }
    },
    degreeDeptChange(row) {
      if (row.degreeDept && row.degreeDept === "其他") {
        row.isShowOtherDept = true;
      } else {
        row.isShowOtherDept = false;
        this.$set(row, "otherDept", "");
      }
    },
    languageRowChange(row) {
      if (row.languageClass && row.languageClass !== "") {
        if (row.languageClass === "英语") {
          row.showDic = true;
        } else {
          row.showDic = false;
        }
        this.$set(row, "languageCertificate", "");
      }
    },
    async getEnglishLevelArray() {
      let res = await getBasicData({ typeCode: "englishLevel" });
      if (res.success) {
        this.basicEnglishLevel = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    async getLanguageArray() {
      let res = await getBasicData({ typeCode: "languageClass" });
      if (res.success) {
        this.basicLanguage = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    loadTreeData(row) {
      if (row.phase === "大学专科毕业" || row.phase === "其它") {
        // return this.treeData1;
        return this.proOneLevelStudy;
      } else {
        return this.oneLevelStudy;
      }
    },
    loadTreeData1(row) {
      if (row.phase === "大学专科毕业" || row.phase === "其它") {
        // return this.treeData1;
        return this.proEduCatalog;
      } else {
        return this.studyCatalog;
      }
    },
    async getSchoolArray() {
      let res = await getUniversity();
      if (res.success) {
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            let object = {};
            object.name = res.data[i];
            object.code = res.data[i];
            this.schoolArray.push(object);
          }
        }
      } else {
        this.$message.error(res.message);
      }
    },
    async loadBasicArray() {
      var result = await getBasicDataBatch({
        typeCodeList: "learningFormat,englishLevel,languageClass,degreeBasic",
      });
      if (result.success) {
        this.basicLearningFormat = result.data.learningFormat;
        this.basicEnglishLevel = result.data.englishLevel;
        this.basicLanguage = result.data.languageClass;
        this.basicDegree = result.data.degreeBasic;
      } else {
        this.$message.error(result.message);
      }
    },
    //学位 1005
    async getDegreeArray() {
      let res = await getBasicData({ typeCode: "degreeBasic" });
      if (res.success) {
        this.basicDegree = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    //学习形式 1005
    async getLearningFormatArray() {
      let res = await getBasicData({ typeCode: "learningFormat" });
      if (res.success) {
        this.basicLearningFormat = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    childDataCheck() {
      let data = this.form;
      let topDegree = data.topDegree;
      if (!topDegree && !this.isTechnique) {
        this.$message.warning("请选择 [最高学历]！");
        return false;
      }
      let experienceList = data.experienceList;
      if (!experienceList || experienceList.length < 1) {
        this.$message.warning("请点击 [添加阶段] 填写学习阶段 ！");
        return false;
      }
      let expList = data.experienceList;
      if (expList && expList.length > 0) {
        for (let i in expList) {
          if (!expList[i].phase) {
            this.$message.warning("教育经历框中请选择 [阶段]！");
            return false;
          }
          if (!expList[i].startDate) {
            this.$message.warning("教育经历框中请填写 [开始时间]！");
            return false;
          }
          if (!expList[i].endDate) {
            this.$message.warning("教育经历框中请填写 [结束时间]！");
            return false;
          }
          if (expList[i].endDate < expList[i].startDate) {
            this.$message.error("教育经历结束时间不能小于开始时间！");
            return false;
          }
          if (!expList[i].university) {
            this.$message.warning("教育经历框中请填写 [毕业单位]！");
            return false;
          }
          if (expList[i].university === "其他" && !expList[i].otherSchool) {
            this.$message.warning("教育经历框中请填写 [其他毕业单位名称]！");
            return false;
          }
          if (!expList[i].studyField) {
            this.$message.warning("教育经历框中请填写 [一级学科]！");
            return false;
          }
          if (expList[i].phase === "大学专科毕业") {
            if (
                !this.isLastLevelCascaderValue(
                    expList[i].studyField,
                    this.proOneLevelStudy
                )
            ) {
              this.$message.warning("教育经历框中[一级学科]不存在匹配数据，请重新选择！");
              return false;
            }
          } else {
            if (
                !this.isLastLevelCascaderValue(
                    expList[i].studyField,
                    this.oneLevelStudy
                )
            ) {
              this.$message.warning("教育经历框中[一级学科]不存在匹配数据，请重新选择！");
              return false;
            }
          }
          if (!expList[i].majorCourse) {
            this.$message.warning("教育经历框中请选择 [毕业专业]！");
            return false;
          }
          if (!expList[i].learningShape) {
            this.$message.warning("教育经历框中请填写 [学习形式]！");
            return false;
          }
          if (expList[i].phase === "大学专科毕业") {
            if (
              !this.isLastLevelCascaderValue(
                expList[i].majorCourse,
                this.proEduCatalog
              )
            ) {
              this.$message.warning("教育经历框中[毕业专业]不存在匹配数据，请重新选择！");
              return false;
            }
          } else {
            if (
              !this.isLastLevelCascaderValue(
                expList[i].majorCourse,
                this.studyCatalog
              )
            ) {
              this.$message.warning("教育经历框中[毕业专业]不存在匹配数据，请重新选择！");
              return false;
            }
          }
        }
      }
      let topDegreeName = data.topDegreeName;
      if (!topDegreeName && !this.isTechnique) {
        this.$message.warning("请选择 [最高学位]！");
        return false;
      }
      let degreeList = data.degreeList;
      if (topDegreeName !== "无") {
        if (!degreeList || degreeList.length < 1) {
          this.$message.warning("请添加学位情况！");
          return false;
        }
      }
      if (degreeList && degreeList.length > 0) {
        for (let i in degreeList) {
          if (!degreeList[i].degreeName) {
            this.$message.warning("学位情况框中请选择 [学位]！");
            return false;
          }
          if (!degreeList[i].startDate) {
            this.$message.warning("学位情况框中请选择 [开始时间]！");
            return false;
          }
          if (!degreeList[i].endDate) {
            this.$message.warning("学位情况框中请选择 [结束时间]！");
            return false;
          }
          if (degreeList[i].endDate < degreeList[i].startDate) {
            this.$message.error("学位情况结束时间不能小于开始时间！");
            return false;
          }
          if (!degreeList[i].degreeDept) {
            this.$message.warning("教育经历框中请填写 [学位授予单位]！");
            return false;
          }
          if (expList[i].degreeDept === "其他" && !expList[i].otherDept) {
            this.$message.warning("教育经历框中请填写 [其他具体单位名称]！");
            return false;
          }
          if (!degreeList[i].learningFormat) {
            this.$message.warning("教育经历框中请填写 [学习形式]！");
            return false;
          }
          if (!degreeList[i].degreeScience) {
            this.$message.warning("教育经历框中请填写 [获学位学科]！");
            return false;
          }
          if (
              !this.isLastLevelCascaderValue(
                  degreeList[i].degreeScience,
                  this.oneLevelStudy
              )
          ) {
            this.$message.warning(
                "学位情况框中[获学位学科]不存在匹配数据，请重新选择！"
            );
            return false;
          }
          if (!degreeList[i].degreeStudyField) {
            this.$message.warning("教育经历框中请填写 [获学位专业]！");
            return false;
          }
          if (
            !this.isLastLevelCascaderValue(
              degreeList[i].degreeStudyField,
              this.studyCatalog
            )
          ) {
            this.$message.warning(
              "学位情况框中[获学位专业]不存在匹配数据，请重新选择！"
            );
            return false;
          }
        }
      }
      if (data.languageInfoList.length === 0) {
        this.$message.warning("语言情况不能为空！");
        return false;
      }
      for (let i = 0; i < data.languageInfoList.length; i++) {
        let languageInfo = data.languageInfoList[i];
        if (!languageInfo.languageClass || languageInfo.languageClass === "") {
          this.$message.warning(
            "语言情况框第" + (i + 1) + "行语言语种不能为空！"
          );
          return false;
        }
        if (
          !languageInfo.languageCertificate ||
          languageInfo.languageCertificate === ""
        ) {
          this.$message.warning(
            "语言情况框第" + (i + 1) + "行语言证书不能为空！"
          );
          return false;
        }
        if (!languageInfo.languageScore || languageInfo.languageScore === "") {
          this.$message.warning(
            "语言情况框第" + (i + 1) + "行证书成绩不能为空！"
          );
          return false;
        }
      }
      return true;
    },
    back() {
      this.$router.back();
    },
    nextActice() {
      if (!this.childDataCheck()) {
        return;
      }
      this.$emit("nextActice");
    },
    preActive() {
      if (!this.childDataCheck()) {
        return;
      }
      this.$emit("preActive");
    },
    topDegreeNameChange(value) {
      if (value == "无") {
        this.form.degreeList = [];
      }
      if (value.includes("学士")) {
        this.form.degreeList = [{ degreeName: value, resumeId: this.form.id }];
      } else if (value.includes("硕士")) {
        this.form.degreeList = [
          { degreeName: "", resumeId: this.form.id },
          { degreeName: value, resumeId: this.form.id },
        ];
      } else if (value.includes("博士")) {
        this.form.degreeList = [
          { degreeName: "", resumeId: this.form.id },
          { degreeName: "", resumeId: this.form.id },
          { degreeName: value, resumeId: this.form.id },
        ];
      }
    },
    topDegreeChange(value) {
      if (value == "其它") {
        this.form.experienceList = [];
      }
      if (value == "大学专科毕业") {
        this.form.experienceList = [
          { phase: "大学专科毕业", resumeId: this.form.id },
        ];
      } else if (value == "大学本科毕业") {
        this.form.experienceList = [
          { phase: "大学本科毕业", resumeId: this.form.id },
        ];
      } else if (value == "硕士研究生毕业") {
        this.form.experienceList = [
          { phase: "大学本科毕业", resumeId: this.form.id },
          { phase: "硕士研究生毕业", resumeId: this.form.id },
        ];
      } else if (value == "博士研究生毕业") {
        this.form.experienceList = [
          { phase: "大学本科毕业", resumeId: this.form.id },
          { phase: "硕士研究生毕业", resumeId: this.form.id },
          { phase: "博士研究生毕业", resumeId: this.form.id },
        ];
      }
    },
    // 添加阶段
    addPhase() {
      this.form.experienceList.push({
        resumeId: this.form.id,
        basicMajorCourse: [],
      });
    },
    //添加学位
    addDegree() {
      this.form.degreeList.push({ resumeId: this.form.id });
    },
    // 删除阶段
    deletePhase(row) {
      this.form.experienceList.splice(
        this.form.experienceList.findIndex((item) => item.phase === row.phase),
        1
      );
    },
    //删除学位
    deleteDegree(row) {
      this.form.degreeList.splice(
        this.form.degreeList.findIndex(
          (item) => item.deleteDegree === row.deleteDegree
        ),
        1
      );
    },
    phaseChange(row) {
      // row.studyField = "";
      this.$set(row, "studyField", "");
      this.$set(row, "majorCourse", "");
    },
    // 综合排名只能输入数字的控件bug
    salaryChange(e, row) {
      row.rankNum = e.target.value;
    },
    // 综合排名只能输入数字的控件bug
    salaryNewChange(e, row) {
      row.totalNumber = e.target.value;
    },
    addLanguageInfo() {
      const newRow = {
        id: this.form.languageInfoList.length + 1,
        isEdit: true,
      };
      this.form.languageInfoList.push(newRow);
    },
    delLanguageInfo(row) {
      const index = this.form.languageInfoList.findIndex(
        (e) => e.id === row.id
      );
      if (index !== -1) {
        this.form.languageInfoList.splice(index, 1);
      }
    },
    majorCourseChnage(row) {
      const lastIndex = row.majorCourse.lastIndexOf(",");
      let studyFieldValue = row.majorCourse.substring(0, lastIndex);
      this.$set(row, "studyField", studyFieldValue);
    },
    degreeStudyFieldChange(row) {
      const lastIndex = row.degreeStudyField.lastIndexOf(",");
      let degreeScienceValue = row.degreeStudyField.substring(0, lastIndex);
      this.$set(row, "degreeScience", degreeScienceValue);
    },
  },
};
</script>
<style scoped>
.tip-class {
  background: #f3f9ff;
  border: 1px solid #69b7ff;
  padding: 10px;
  border-radius: 2px;
  margin: 15px;
}
.containerInfo {
  background-color: #f6f8f9;
  border-color: #f6f8f9;
}
</style>
